import { render } from "./Depenses.vue?vue&type=template&id=7304ca72"
import script from "./Depenses.vue?vue&type=script&lang=js"
export * from "./Depenses.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__